export default __webpack_public_path__ + "static/media/twitter.9a8d3a1f.svg";